<template>
  <div>
    <div style="margin-top: 20px; text-align: center">
      <h3>
        Error in connect to payment getway website. Please check your network.
      </h3>
    </div>
    <div style="color: red; margin-top: 20px; text-align: center">
      <h4>Redirect back to application form and retry!</h4>
    </div>
    <div style="color: red; margin-top: 20px; text-align: center">
      <img
        src="../assets/images/payerror.gif"
        style="height: 20%; width: 20%"
      />
    </div>
    <div style="text-align: center">
      <input
        type="button"
        id="btnBackToApp"
        value="Back to Application"
        v-on:click="backToApplication()"
      />
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Router from "vue-router";
import config from "@/router/globalConfig";
export default {
  name: "TransError",
  data() {
    return {
      bookingID: "-1",
      PayBooking: [],
    };
  },
  methods: {
    backToApplication() {
      this.$root.$data.isSuccess = false;
      this.$root.$data.BookingID = this.bookingID;
      this.$router.push({ name: "TicketBooking" });
    },
  },
  mounted() {
    if (this.$root.$data.BookingID != -1) {
      this.bookingID = this.$root.$data.BookingID;
      // console.log(this.bookingID);
    }
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/TransError.vue